// extracted by mini-css-extract-plugin
module.exports = {"activitiesContainer":"Activities_activitiesContainer__3iZPm","center":"Activities_center__300mI","noAct":"Activities_noAct__qt6Z5"};